<script setup lang="ts">
const props = defineProps<{
  title?: string
  showAll?: boolean
  noTopMargin?: boolean
  range?: [number, number]
  articles?: ArticleCard[]
}>()

const actualRange = computed<[number, number]>(() => {
  const max = Math.max(...ARTICLE_CARD_COLUMNS)
  if (!props.range) {
    return [0, max]
  }

  const [start, end] = props.range

  if (end - start > max) {
    return [start, start + max]
  }

  return props.range
})

// FIXME: Only fetch if there are no articles provided through props
const cardsQuery = useArticleCards()

if (!props.articles?.length) {
  await cardsQuery.suspense()
}

const cards = computed(() => {
  const [start, end] = actualRange.value
  const data = props.articles ?? cardsQuery.data.value ?? []
  return data.slice(start, end)
})
</script>

<template>
  <section v-if="cards.length > 0" class="py-8">
    <UContainer>
      <h2
        v-if="title"
        class="my-4 text-center text-versal-lg tablet:my-8 tablet:text-left"
        :class="{
          'mt-0': noTopMargin,
          'text-center': !showAll,
        }"
        v-text="title"
      />
      <div
        class="flex flex-wrap items-stretch justify-center gap-6 tablet:justify-between"
        :class=" {
          'tablet:justify-start': cards.length < 3,
        }"
      >
        <CardsArticle
          v-for="article in cards"
          :key="article.id"
          :article="article"
          :width-factor="ARTICLE_CARD_COLUMNS.find((it) => it === cards.length)"
        />
      </div>
      <NuxtLink
        v-if="showAll"
        class="my-8 flex items-center justify-center gap-4 text-inherit no-underline transition-transform duration-200 ease-in-out hover:translate-x-3 tablet:mt-12 tablet:mb-16 tablet:justify-start"
        :to="{ name: 'articles' }"
      >
        <UIcon name="fal:arrow-right-long" size="1.75em" />
        <span class="text-base font-medium xs:text-xl">Se alle artikler</span>
      </NuxtLink>
    </UContainer>
  </section>
</template>
